import "core-js/modules/es.array.for-each";
import "core-js/modules/web.dom-collections.for-each";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import smoothscroll from 'smoothscroll-polyfill';

var Accordion = /*#__PURE__*/function () {
  function Accordion(container) {
    var siblingAccordions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, Accordion);

    this.siblings = siblingAccordions;
    this.wrapper = container;
    this.trigger = container.querySelector('.accordion__trigger');
    this.text = container.querySelector('.accordion__text');
    this.content = container.querySelector('.accordion__content');
    this.settings = settings;
    this.directLinkClass = null;
    this.breakpoint = null;
    this.onResize = this.onResize.bind(this);
  }

  _createClass(Accordion, [{
    key: "setSettings",
    value: function setSettings() {
      if (this.settings) {
        this.directLinkClass = this.settings.directLinkClass;
        this.breakpoint = this.settings.breakpoint ? window.matchMedia("(min-width: ".concat(this.settings.breakpoint, "px)")) : null;
      }
    }
  }, {
    key: "closeSiblingAccordions",
    value: function closeSiblingAccordions() {
      if (this.siblings.length > 0) {
        this.siblings.forEach(function (sibling) {
          return sibling.close();
        });
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.content.classList.remove('accordion__content--expanded');
      this.trigger.classList.remove('accordion__trigger--expanded');
      this.content.removeAttribute('style');

      if (this.text) {
        this.text.innerText = this.trigger.dataset.openText;
      }
    }
  }, {
    key: "onTriggerClick",
    value: function onTriggerClick(e) {
      var _this = this;

      if (!e.target.classList.contains(this.directLinkClass)) {
        e.preventDefault();

        if (!this.content.classList.contains('accordion__content--expanded')) {
          this.closeSiblingAccordions();
          this.content.classList.add('accordion__content--expanded');
          this.content.style.maxHeight = "".concat(this.content.querySelector('.accordion__content-inner').getBoundingClientRect().height, "px");
          this.trigger.classList.add('accordion__trigger--expanded');

          if (this.text) {
            this.text.innerText = this.trigger.dataset.closeText;
          }

          var openAccordion = setTimeout(function () {
            _this.wrapper.scrollIntoView({
              behavior: 'smooth'
            });

            clearTimeout(openAccordion);
          }, 300);
        } else {
          this.closeSiblingAccordions();
          this.content.removeAttribute('style');
          this.content.classList.remove('accordion__content--expanded');
          this.trigger.classList.remove('accordion__trigger--expanded');

          if (this.text) {
            this.text.innerText = this.trigger.dataset.openText;
          }
        }

        return true;
      }
    }
  }, {
    key: "onResize",
    value: function onResize(e) {
      var _this2 = this;

      if (e.matches) {
        this.close();
        this.trigger.removeEventListener('click', this.onTriggerClick);
      } else {
        this.trigger.addEventListener('click', function (e) {
          return _this2.onTriggerClick(e);
        });
      }
    }
  }, {
    key: "initiateListeners",
    value: function initiateListeners() {
      var _this3 = this;

      this.setSettings();

      if (this.breakpoint !== null) {
        this.onResize(this.breakpoint);
        this.breakpoint.addListener(this.onResize);
      } else {
        this.trigger.addEventListener('click', function (e) {
          return _this3.onTriggerClick(e);
        });
      }
    }
  }, {
    key: "init",
    value: function init() {
      //IOS polyfills
      smoothscroll.polyfill();
      this.initiateListeners();
    }
  }]);

  return Accordion;
}();

export { Accordion as default };